var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "add-album-button",
      class: { "modal-item": _vm.modalItem, high: _vm.high },
      on: { click: _vm.onClick }
    },
    [
      _c(
        "svg",
        {
          attrs: {
            width: "59",
            height: "59",
            viewBox: "0 0 59 59",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg"
          }
        },
        [
          _c("g", { attrs: { opacity: "0.5" } }, [
            _c("path", {
              attrs: {
                d:
                  "M0 29.5C0 27.6897 1.46751 26.2222 3.27778 26.2222H55.7222C57.5325 26.2222 59 27.6897 59 29.5C59 31.3103 57.5325 32.7778 55.7222 32.7778H3.27778C1.46751 32.7778 0 31.3103 0 29.5Z",
                fill: "url(#paint0_linear_" + _vm.id + ")"
              }
            }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d:
                  "M29.5 0C31.3103 7.91293e-08 32.7778 1.46751 32.7778 3.27778L32.7778 55.7222C32.7778 57.5325 31.3103 59 29.5 59C27.6897 59 26.2222 57.5325 26.2222 55.7222L26.2222 3.27778C26.2222 1.46751 27.6897 -7.91293e-08 29.5 0Z",
                fill: "url(#paint0_linear_" + _vm.id + ")"
              }
            })
          ]),
          _vm._v(" "),
          _c(
            "defs",
            [
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "paint0_linear_" + _vm.id,
                    x1: "29.5",
                    y1: "0",
                    x2: "29.5",
                    y2: "59",
                    gradientUnits: "userSpaceOnUse"
                  }
                },
                [
                  _c("stop", { attrs: { "stop-color": "#2659D2" } }),
                  _vm._v(" "),
                  _c("stop", {
                    attrs: { offset: "1", "stop-color": "#34A6E7" }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "linearGradient",
                {
                  attrs: {
                    id: "paint0_linear_" + _vm.id,
                    x1: "29.5",
                    y1: "0",
                    x2: "29.5",
                    y2: "59",
                    gradientUnits: "userSpaceOnUse"
                  }
                },
                [
                  _c("stop", { attrs: { "stop-color": "#2659D2" } }),
                  _vm._v(" "),
                  _c("stop", {
                    attrs: { offset: "1", "stop-color": "#34A6E7" }
                  })
                ],
                1
              )
            ],
            1
          )
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }